/**
 * Fields shown for a `static` (secret-only) login provider.
 */

import type { ReactElement } from 'react';
import type { ProviderFormData, SetProviderField } from './providerFormTypes';

interface StaticProviderFieldsProps {
  form: ProviderFormData;
  setField: SetProviderField;
}

export function StaticProviderFields({
  form,
  setField,
}: StaticProviderFieldsProps): ReactElement {
  return (
    <>
      <label className="dialog__field">
        Secret Label
        <input
          value={form.secret_label ?? ''}
          onChange={(e) => { setField('secret_label', e.target.value || null); }}
          placeholder="e.g. API token"
        />
      </label>
      <label className="dialog__field">
        Help Text
        <textarea
          value={form.help_text ?? ''}
          onChange={(e) => { setField('help_text', e.target.value || null); }}
          rows={2}
        />
      </label>
    </>
  );
}
